// Define an enum for the different modules
export enum ApiModules {
  AUTH = "Authentification",
  PROJET = "Gestion de projet",
  FORUM = "Gestion de forum",
  RESOURCES_PUBLICATION = "Gestion des resources de publication",
  MENTORAT="mentorat"
}
